import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatTableModule } from '@angular/material/table';
import { BaseModalComponent } from '@app/components/base-modal/base-modal.component';
import { RimsStepInfo } from '@app/models/rims.model';

@Component({
  standalone: true,
  selector: 'app-add-rims-step-modal',
  imports: [
    MatIconModule,
    MatRadioModule,
    MatTableModule,
    FormsModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    BaseModalComponent,
  ],
  templateUrl: './add-rims-step-modal.component.html',
  styleUrl: './add-rims-step-modal.component.scss',
})
export class AddRimsStepModalComponent {
  protected selectedRimsStepInfo?: RimsStepInfo;
  protected rimsStepsGridColumns: (keyof RimsStepInfo | 'selectRadio')[] = [
    'selectRadio',
    'stepId',
    'stepName',
    'description',
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { rimsStepInfos: RimsStepInfo[] },
    private readonly dialogRef: MatDialogRef<AddRimsStepModalComponent, string>,
  ) {}

  protected onAdd(): void {
    this.dialogRef.close(this.selectedRimsStepInfo?.stepId);
  }

  protected onCancel(): void {
    this.dialogRef.close();
  }
}
